import type { ConnectedClient } from "../user-toolbar/schemas";
import { createEventHook } from "@vueuse/core";
import { defineStore } from "pinia";
import { ref } from "vue";
import { setFollowing as dotnetSetFollowing } from "../interop/dotnetExports/bridge";
import { useDocumentStore } from "../store/document";
import { useBusEmitterListener } from "./index";

const connectedClientsUpdatedEvent = Symbol("hubClient:connectedClientsChanged");
const mouseStatusChangedEvent = Symbol("hubClient:mouseStatusChanged");

export const userFollowed = createEventHook<string>();

export const {
  emitter: connectedClientsChanged,
  listener: onConnectedClientsChanged,
} = useBusEmitterListener(connectedClientsUpdatedEvent);

export const {
  emitter: mouseStatusChanged,
  listener: onMouseStatusChanged,
} = useBusEmitterListener<string>(mouseStatusChangedEvent);

export const useCollaborationStore = defineStore("collaboration", () => {
  const following = ref<ConnectedClient>();
  const followers = ref(new Map<string, string>());

  const document = useDocumentStore();
  function follow(client: ConnectedClient) {
    following.value = client;
    dotnetSetFollowing(client.connectionId);
    if (document.shortcut) {
      userFollowed.trigger(document.shortcut);
    }
  }

  function unfollow() {
    following.value = undefined;
    dotnetSetFollowing("");
  }

  function setFollowers(connectionId: string, following: string) {
    followers.value.set(connectionId, following);
  }

  return {
    following,
    followers,
    follow,
    unfollow,
    setFollowers,
  };
});

export function followingEnded() {
  useCollaborationStore().unfollow();
}

const restoreBackupStartedEvent = Symbol("bridge:restoreBackupStarted");
export const {
  emitter: restoreBackupStarted,
  listener: onRestoreBackupStarted,
} = useBusEmitterListener<string>(restoreBackupStartedEvent);

export function backupRestored() {
  window.location.reload();
}

export function connectedClientFollowingChanged(connectionId: string, following: string) {
  useCollaborationStore().setFollowers(connectionId, following);
}
